import React from 'react';
import { IconUIComponentProps, useIconStyle } from './Icon';

export default function ({ size, color, style, noFill, className }: IconUIComponentProps) {
  const styles = useIconStyle({ noFill });
  return (
    <svg
      className={[styles.icon, className].join(' ')}
      fontSize={size}
      color={color}
      style={style}
      viewBox="0 0 24 16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.47045 5.82549C5.96431 3.54912 7.42543 1.63477 9.43792 0.666746C12.8863 -0.993234 16.9245 0.553206 18.6177 4.11987C21.6017 4.18997 24 6.79421 24 9.99717C24 13.2442 21.5352 15.8759 18.4942 15.8759L4.61957 15.8757C4.23455 15.865 3.85178 15.8046 3.47645 15.6954C0.955481 14.9518 -0.5237 12.168 0.171753 9.47597C0.819816 6.97138 3.12276 5.42926 5.47045 5.82549ZM4.63257 14.8082H18.4942C20.9829 14.8082 23 12.6545 23 9.99716C23 7.33981 20.9829 5.18611 18.4942 5.18611H18.3022C18.1056 5.18611 17.9273 5.06312 17.8464 4.8718C16.473 1.62129 12.8931 0.174678 9.84878 1.64015C7.98329 2.53747 6.66997 4.38245 6.35871 6.54317C6.31321 6.85897 6.01983 7.06167 5.73139 6.97658C3.7429 6.39 1.68514 7.63652 1.13567 9.76008C0.58708 11.8836 1.75393 14.0796 3.74103 14.6658C4.03763 14.752 4.34089 14.7999 4.63257 14.8082Z"
      />
      <path d="M13 11.8303L17.1251 6.88192C17.3078 6.66276 17.6237 6.64185 17.8308 6.83522C18.0379 7.02858 18.0576 7.363 17.8749 7.58215L12.8749 13.5801C12.6799 13.8141 12.3368 13.8195 12.1352 13.5919L7.13521 7.9464C6.94636 7.73317 6.95659 7.39827 7.15805 7.19839C7.35952 6.99851 7.67594 7.00934 7.86479 7.22257L12 11.8916L12 0.529228C12.5 0.529228 12.5 0.529228 12.5 0.529228L13 0.529228L13 11.8303Z" />
    </svg>
  );
}